import { useTranslation } from 'react-i18next';
import React from 'react';
import { composeClassName } from '@/utils/util_helpers';
import { theme } from '@/utils/util_theme';
import { IconSaxIcon } from '@/components/design-system/atoms/icon';
import { IconSaxIconName } from '@/components/design-system/atoms/icon/iconsax-icon/types';

export type ContractStatus =
  | 'activated'
  | 'applied'
  | 'signed'
  | 'cancelled'
  | 'terminated'
  | 'accepted'
  | 'signed'
  | 'overdue'
  | 'notice_of_termination_received';

interface ContractStatusCellContentProps {
  status: ContractStatus;
}

const ContractStatusCellContent: React.FC<ContractStatusCellContentProps> = ({ status }) => {
  const { t } = useTranslation();

  const bgColor: { [key in ContractStatus]: string } = {
    activated: 'bg-J300',
    applied: 'bg-Q300',
    signed: 'bg-J300',
    cancelled: 'bg-R700',
    terminated: 'bg-R700',
    accepted: 'bg-B300',
    overdue: 'bg-E30',
    notice_of_termination_received: 'bg-E75',
  };

  const borderColor: { [key in ContractStatus]: string } = {
    activated: 'border-J300',
    applied: 'border-Q300',
    signed: 'border-J300',
    cancelled: 'border-R700',
    terminated: 'border-R700',
    accepted: 'border-B300',
    overdue: 'border-transparent',
    notice_of_termination_received: 'border-E75',
  };

  const textColor: { [key in ContractStatus]: string } = {
    activated: 'white',
    applied: 'white',
    signed: 'white',
    cancelled: 'white',
    terminated: 'white',
    accepted: 'text-[#212529]',
    overdue: 'white',
    notice_of_termination_received: 'white',
  };

  return (
    <div className="inline-block">
      <div
        className={composeClassName(
          'flex items-center gap-1 rounded-[19px] border-[1px] border-solid px-2 py-1',
          borderColor[status],
          bgColor[status]
        )}
      >
        <span className={composeClassName('text-body')} style={{ color: textColor[status] }}>
          {t(`js.features.admin.contracts.list.status.${status}`)}
        </span>
      </div>
    </div>
  );
};

export { ContractStatusCellContent };
